import AbstractUser from './abstract';

/**
 * @class NeonUser
 * @description NeonUser
 */
class NeonUser extends AbstractUser {

    /**
     * Constructs the User
     * @param {Object} props - user properties
     * @param {string} props.username - username
     * @param {Array} props.roles - roles array
     */
    constructor(props) {
        super({
            id: props.uuid,
            username: props.username,
            roles: props.roles,
            firstName: props.firstName,
            infix: props.infix,
            lastName: props.lastName,
            csrfToken: props.csrfToken
        });

        this.gender = props.gender || null;
        this.educationLevel = props.educationLevel || null;
        this.created = props.created || null;
        this.isTenantUser = props.isTenantUser || null;
        this.activeOrganisationTenant = props.activeOrganisationTenant || null;
        this.hasMultipleTenants = props.hasMultipleTenants || null;
        this.language = props.language || null;
        this.accountId = props.accountId || null;
        this.visitedPages = props.visitedPages || null;
    }

    /**
     * Returns the gender
     * @returns {string|null} gender
     */
    getGender() {
        return this.gender;
    }

    /**
     * Returns the education level
     * @returns {string|null} education level
     */
    getEducationLevel() {
        return this.educationLevel;
    }

    /**
     * Returns the creation date
     * @returns {string|null} creation date
     */
    getCreated() {
        return this.created;
    }

    /**
     * Returns whether this user is a tenant user
     * @returns {bool|null} is tenant user
     */
    getIsTenantUser() {
        return this.isTenantUser;
    }

    /**
     * Returns the active organisation tenant for this user (session)
     * @returns {string|null} active organisation tenant
     */
    getActiveOrganisationTenant() {
        return this.activeOrganisationTenant;
    }

    /**
     * Returns whether this user has multiple tenants
     * @returns {bool|null} has multiple tenants
     */
    getHasMultipleTenants() {
        return this.hasMultipleTenants;
    }
}

export default NeonUser;
